<template>
    <form
        ref="form"
        @submit.prevent="submit"
        :action="formRoute"
        method="POST"
        class="relative h-full"
    >
        <page-header
            :submit-button-text="data ? 'Update' : 'Create'"
            :show-submit-button="true"
            :submit-button-disabled="submitButtonDisabled || !editable"
            submit-button-type="submit"

            :can-delete="canDelete"
            :delete-route="deleteRoute"
            :delete-value="deleteValue"

            :can-create="canCreate"
            :create-route="createRoute"
            :create-value="createValue"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :show-preview-button="false"

            :errors="errors"
            :is-slide-over="isSlideOver"

            :version-id="versionId"
            :init-version-id="initVersionId"
            :last-updated-by="lastUpdatedBy"
        />

        <input-text
            name="name"
            label="* Name"
            v-model="form.name"
            :error="errors.name ? errors.name[0] : null"
        />

        <input-text
            label="* Key"
            name="key"
            v-model="form.key"
            :error="errors.key ? errors.key[0] : null"
            class="mt-3"
            :disabled="data ? true : false"
        />

        <input-text
            label="Description"
            name="description"
            v-model="form.description"
            :error="errors.description ? errors.description[0] : null"
            class="mt-3"
        />

        <input-textarea
            label="English Value"
            name="value"
            v-model="form.value"
            :error="errors.value ? errors.value[0] : null"
            class="mt-3"
        />
        <div v-if="form.translations.length">
            <div v-for="(language, index) in languages" :key="index">
                <input-textarea
                    :label="`${language.name} Value`"
                    :name="`translations[][${language.name}]`"
                    v-model="form.translations[index].value"
                    :error="getError(index)"
                    class="mt-3"
                />
            </div>
        </div>
        <input type="hidden" name="_token" :value="csrf" />
        <input v-if="data" type="hidden" name="_method" value="patch" />
    </form>
</template>

<script>
import crudForm from "../mixins/crudForm";
export default {
    name: "TranslationForm",
    mixins: [crudForm],
    props: {
        languages: {
            type: Array,
            required: true,
        }
    },
    data() {
        return {
            form: {
                name: this.getFormData("name"),
                key: this.getFormData("key"),
                description: this.getFormData("description"),
                value: this.getFormData("value"),
                translations: [],
            },
        };
    },
    mounted: function(){
        this.form.translations = this.languages.map(language => {
            return {
                language_id: language['id'],
                language_name: language['name'],
                value: this.extractValue(language['id']),
            }
        });
    },
    methods: {
        extractValue: function(languageId){
            if(!this.data){
                return "";
            }
            const translation = this.data.translations.filter(translation => translation.language_id === languageId)
            if(translation[0]){
                return translation[0].value;
            }else{
                return "";
            }
        },
        getError: function(index) {
            return this.errors[`translations.${index}.value`]
                ? this.errors[`translations.${index}.value`].join('. ')
                : null
        }
    }
};
</script>
